export default "Click for an example!\n";